<template>
  <div>
    <div
      class="link_container"
      :class="{ space_container_links: !isSection }"
    >
      <jade-link
        :href="$sanitize(entity.logs_url.seq)"
        rel="noopener noreferrer"
        target="_blank"
        variant="brand"
        external
      >
        {{ $t('log-links.seq') }}
      </jade-link>

      <jade-link
        :href="$sanitize(entity.logs_url.splunk)"
        rel="noopener noreferrer"
        target="_blank"
        variant="brand"
        external
      >
        {{ $t('log-links.splunk') }}
      </jade-link>
    </div>
  </div>
</template>

<script>
import { JadeLink } from '@jade'
export default {
  name: 'LogLinks',
  components: {
    JadeLink
  },
  props: {
    isSection: {
      type: Boolean,
      default: true
    },
    entity: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.link_container {
  display: flex;
  gap: var(--global-space-200, 16px);
}

.space_container_links {
  padding-top: var(--global-space-200, 16px);
}
</style>
